import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSlider } from "./SliderContext";

const RightSlider = () => {
  const { isSliderOpen, setIsSliderOpen } = useSlider();
  const [courses, setCourses] = useState([]);
  const [formData, setFormData] = React.useState({
    name: "",
    email: "",
    phone: "",
    position: "",
    message: "",
  });

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get(
          "https://training.megascale.co.in/backend/get_courses.php"
        );
        console.log("Fetched Courses:", response.data); // ✅ Debugging log
        setCourses(response.data.courses || []); // ✅ Ensure courses is not undefined
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };
    fetchCourses();
  }, []);
  

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://training.megascale.co.in/backend/save_contact.php",
        formData
      );
      if (response.data.success) {
        alert("Data submitted successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          position: "",
          message: "",
        });
        setIsSliderOpen(false);
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form data:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div>
      {/* ✅ Button to Open the Slider */}
      {!isSliderOpen && (
        <div
          className="fixed top-1/2 right-0 transform -translate-y-1/2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white w-10 h-10 flex items-center justify-center rounded-l-lg cursor-pointer z-50 hover:shadow-md"
          onClick={() => setIsSliderOpen(true)}
        >
          <span className="rotate-[180deg] font-bold text-xl"> → </span>
        </div>
      )}

      {/* ✅ Right Slider Panel */}
      <div
        className={`fixed top-0 right-0 h-screen bg-gradient-to-b from-blue-50 to-indigo-50 shadow-lg z-40 transition-transform duration-300 ${isSliderOpen ? "translate-x-0" : "translate-x-full"
          } w-full sm:w-96`}
      >
        <div className="p-6 flex flex-col h-full">
          {/* ✅ Close Button */}
          <div
            className="self-end text-gray-600 text-4xl cursor-pointer hover:text-gray-900"
            onClick={() => setIsSliderOpen(false)}
          >
            ×
          </div>
          <h2 className="text-2xl font-extrabold text-indigo-800 mb-2">Let's Get In Touch</h2>
          <form className="space-y-3 flex-grow" onSubmit={handleSubmit}>
            <div>
              <label className="block text-gray-700 font-medium mb-2">Full Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 transition duration-200"
                placeholder="Enter your name"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 transition duration-200"
                placeholder="Enter your email"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2">Phone Number</label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 transition duration-200"
                placeholder="Enter your phone number"
                required
              />
            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2">
                Courses
              </label>
              <select
                name="position"
                value={formData.position}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 transition duration-200 text-gray-600"
                required
              >
                <option value="">Select a Course</option> 
                {courses.map((course) => (
                  <option key={course.id} value={course.title}>
                    {course.title}
                  </option>
                ))}
              </select>

            </div>
            <div>
              <label className="block text-gray-700 font-medium mb-2">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-600 transition duration-200"
                placeholder="Enter your message"
                rows="4"
                required
              ></textarea>
            </div>
            <button type="submit" className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition duration-300">
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RightSlider;
